import { useTechnique, useUpdateTechnique } from '../../hooks/useTechniques';

import { TechniqueForm } from './TechniqueForm';

import { PageHeader } from '@/components/common/PageHeader';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { useNavigate, useParams } from '@/lib/router';

export function EditTechniquePage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const navigate = useNavigate();
  const { data: technique, isLoading } = useTechnique(id);
  const updateTechnique = useUpdateTechnique();

  if (isLoading) {
    return (
      <AppShell>
        <TopBar title="Chargement..." />
        <div className="flex h-64 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-green-600 border-t-transparent" />
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <TopBar title={`Modifier : ${technique?.name ?? ''}`} />
      <div className="mx-auto max-w-4xl p-4 md:p-6">
        <PageHeader title={`Modifier "${technique?.name ?? ''}"`} />
        <TechniqueForm
          mode="edit"
          defaultValues={technique}
          isLoading={updateTechnique.isPending}
          onCancel={() => void navigate({ to: '/techniques' })}
          onSubmit={async (data) => {
            await updateTechnique.mutateAsync({
              id,
              data: data as Parameters<typeof updateTechnique.mutateAsync>[0]['data'],
            });
            await navigate({ to: '/techniques' });
          }}
        />
      </div>
    </AppShell>
  );
}
